import { NavBarItem, NavBarSection } from '@lessonnine/design-system.lib';
import PropTypes from 'prop-types';
// External Imports
import React from 'react';
import { connect } from 'react-redux';

import { createSelectTranslation } from '../../../selectors/createSelectTranslation.mjs';
import { selectLanguage } from '../../../selectors/selectMatch.mjs';
// Internal Imports
import { selectNavigationText } from '../../../selectors/selectNavigationText.mjs';
import { DisclosureMenu } from '../../DisclosureMenu/DisclosureMenu.jsx';
import { DisclosureMenuLink } from '../../DisclosureMenu/DisclosureMenuLink.jsx';
import { NavBarLink } from '../../Link/NavBarLink.jsx';
import { buildExploreLink } from './buildExploreLink.mjs';

// Component Definition
function DesktopNavExploreBase({ getTranslation, language, navigationTextObj }) {
  const buildLanguageLink = (languages) =>
    languages.map((link) => (
      <DisclosureMenuLink
        key={link.label}
        to={buildExploreLink({ langCode: language, link, urlPrefix: 'tags' })}
      >
        {link.label}
      </DisclosureMenuLink>
    ));

  return (
    // TODO: follow-up whether NavBarSection should be a section tag in the design-system given the naming
    <section aria-label={getTranslation('categories', 'Explore')}>
      <NavBarSection direction="inline">
        {navigationTextObj.categories && navigationTextObj.categories.length > 0
          ? navigationTextObj.categories.map((link) => (
              <NavBarItem key={link.label}>
                <NavBarLink
                  key={link.label}
                  link={link}
                  to={buildExploreLink({
                    langCode: language,
                    link,
                    urlPrefix: 'category',
                  })}
                >
                  {link.label}
                </NavBarLink>
              </NavBarItem>
            ))
          : undefined}
        {navigationTextObj.aboutLanguages && navigationTextObj.aboutLanguages.length > 0 ? (
          <DisclosureMenu
            items={buildLanguageLink(navigationTextObj.aboutLanguages)}
            label={getTranslation('languages', 'Languages')}
            navLabelId={{ button: true }}
          />
        ) : undefined}
      </NavBarSection>
    </section>
  );
}

DesktopNavExploreBase.propTypes = {
  getTranslation: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- fix when migrating to TS
  navigationTextObj: PropTypes.object.isRequired,
};

const mapStateToProperties = (state) => ({
  getTranslation: createSelectTranslation(state),
  language: selectLanguage(state),
  navigationTextObj: selectNavigationText(state),
});

const withRedux = connect(mapStateToProperties);

const DesktopNavExplore = withRedux(DesktopNavExploreBase);

// Module Exports
export { DesktopNavExplore };
